// extracted by mini-css-extract-plugin
export default {"celebration":"celebration_celebration__bfzwq","bottom":"celebration_bottom__Vj7pS"};